import React, { useState } from "react";
import "./ContactPage.css";
// import trophy from "../../assets/pics/trophy1.jpg";

const ContactPage = () => {
  const trophy = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy1.jpg";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await fetch("https://crmhul5sg2.execute-api.eu-west-2.amazonaws.com/dev/contact-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error("Failed to send message. Please try again.");
      }

      setSuccess("Message sent successfully!");
      setShowModal(true);
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact">
      <div className="contact-container">
        <div className="contact-content">
          <span className="contact-topper">Contact Us</span>
          <h2 className="contact-title">We Love to Hear from You</h2>
        </div>
        <div className="contact-group">
          <div className="contact-picture">
            <img src={trophy} alt="trophy-pic" />
          </div>
          <p className="contact-text">
            If you have any questions or would like to support the Gladiators, please contact us at:
          </p>
          <ul className="contact-ul">
              <li className="contact-li">
                <div className="icon-wrapper">
                  <img
                    aria-hidden="true"
                    src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/mech-phone.svg"
                    alt="phone icon"
                    width="40"
                    height="40"
                  />
                </div>
                <div>
                  <span className="contact-header">Phone: </span>
                  <a href="tel:+18884565789" className="contact-link">
                  (0044) 785 289 7207
                  </a>
                </div>
              </li>
              {/* <li className="contact-li">
                <div className="icon-wrapper">
                  <img
                    aria-hidden="true"
                    src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/mech-phone.svg"
                    alt="phone icon"
                    width="40"
                    height="40"
                  />
                </div>
                <div>
                  <span className="contact-header">Email: </span>
                  <a href="tel:+18884565789" className="contact-link">
                  Info@fcgladiatorsbmth.com
                  </a>
                </div>
              </li> */}
              <li className="contact-li">
                <div className="icon-wrapper">
                  <img
                    aria-hidden="true"
                    src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/mech-pin.svg"
                    alt="address icon"
                    width="40"
                    height="40"
                  />
                </div>
                <div>
                  <span className="contact-header">Address: </span>
                  <a
                    href="https://www.google.com/maps"
                    className="contact-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bournemouth, United Kingdom
                  </a>
                </div>
              </li>
            </ul>
        </div>
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <label className="contact-label">
            Name
            <input className="contact-input" required type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} />
          </label>
          <label className="contact-label">
            Email
            <input className="contact-input" required type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
          </label>
          <label className="contact-label">
            Phone
            <input className="contact-input" required type="text" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} />
          </label>
          <label className="contact-label">
            Message
            <textarea className="contact-input contact-textarea" required name="message" placeholder="Write message..." value={formData.message} onChange={handleChange}></textarea>
          </label>
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}
          <button className="contact-button" type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send a Message"}
          </button>
        </form>
      </div>

      {showModal && (
        <div className="contact-modal-overlay">
          <div className="contact-modal-content">
            <p>Message sent successfully!</p>
            <button onClick={() => setShowModal(false)}>OK</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactPage;